import React from 'react'

// Components
import Modal from 'app/views/components/UIkit/Modal'
import TipsForGettingOutput from 'app/views/components/TipsForGettingOutput'

// Settings
import settings from 'settings'


const ModalAboutThisEnvironment = ({ engine, hideOutputTips }) => {
  let version = null
  let libraries = ['-']

  if (engine === 'c') {
    version = 'gcc 7.3.0'
  } else if (engine === 'dotnet') {
    version = '.NET 4.7'
    libraries = [
      'AsyncIO 0.1.26.0',
      'NetMQ 4.0.0.1',
      'System.Directory.DirectoryServices 4.5.0',
      'Google.Protobuf 3.5.1',
      'MySql.Data 8.0.11',
      'Newtonsoft.Json 11.0.2',
      'Microsoft.IdentityModel.Logging 5.2.4',
      'Microsoft.IdentityModel.Tokens 5.2.4',
      'Microsoft.IdentityModel.JsonWebTokens 5.2.4',
      'System.IdentityModel.Tokens.Jwt 5.2.4',
    ]
  } else if (engine === 'go') {
    version = 'Go 1.13.4'
    libraries = [
      'github.com/go-sql-driver/mysql',
      'github.com/dgrijalva/jwt-go',
      'golang.org/x/net/html',
      'golang.org/x/text',
      'gopkg.in/ldap.v3',
      'go.mongodb.org/mongo-driver/mongo',
    ]
  } else if (engine === 'java') {
    version = 'Java: openjdk 13.0.1 2019-10-15'
    libraries = [
      'com.google.guava:guava:23.0',
      'org.zeromq:jeromq:0.4.3',
      'com.googlecode.json-simple:json-simple:1.1.1',
      'mysql:mysql-connector-java:5.1.45',
      'io.jsonwebtoken:jjwt:0.10.7',
      'org.apache.commons:commons-lang3:3.7',
      'org.mongodb:mongo-java-driver:2.12.3',
    ]
  } else if (engine === 'node') {
    version = 'Node 13.5.0'
    libraries = [
      'escape-html ^1.0.3',
      'jsonwebtoken 8.5.1',
      'jwt-decode 2.2.0',
      'libxmljs 0.19.7',
      'mysql 2.17.1',
      'zeromq 5.2.0',
    ]
  } else if (engine === 'php') {
    version = 'PHP 7.2.24'
    libraries = [
      'firebase/php-jwt 5.0.0',
      'react/zmq 0.4.0',
    ]
  } else if (engine === 'python') {
    version = 'Python 3.6.9'
    libraries = [
      'asn1crypto==0.24.0',
      'certifi==2019.11.28',
      'chardet==3.0.4',
      'cryptography==2.1.4',
      'idna==2.6',
      'keyring==10.6.0',
      'keyrings.alt==3.0',
      'ldap3==2.6.1',
      'lxml==4.1.1',
      'pyasn1==0.4.8',
      'pycrypto==2.6.1',
      'pygobject==3.26.1',
      'PyJWT==1.4.2',
      'pymongo==3.10.1',
      'PyMySQL==0.7.11',
      'python-apt==1.6.4',
      'pyxdg==0.25',
      'pyzmq==17.0.0',
      'requests==2.22.0',
      'SecretStorage==2.3.1',
      'six==1.11.0',
      'unattended-upgrades==0.1',
      'untangle==1.1.1',
      'urllib3==1.25.7',
      'xmltodict==0.11.0',
    ]
  } else if (engine === 'ruby') {
    version = 'Ruby 2.5.1'
    libraries = [
      'activesupport (5.2.3)',
      'bigdecimal (default: 1.3.4)',
      'bson (4.7.0)',
      'cmath (default: 1.0.0)',
      'concurrent-ruby (1.1.5)',
      'csv (default: 1.0.0)',
      'date (default: 1.0.0)',
      'dbm (default: 1.0.0)',
      'did_you_mean (1.2.0)',
      'etc (default: 1.0.0)',
      'faraday (1.0.0)',
      'fcntl (default: 1.0.0)',
      'ffi (1.11.3)',
      'ffi-rzmq (2.0.7)',
      'ffi-rzmq-core (1.0.7)',
      'fiddle (default: 1.0.0)',
      'fileutils (default: 1.0.2)',
      'gdbm (default: 2.0.0)',
      'i18n (1.8.1)',
      'io-console (default: 0.4.6)',
      'ipaddr (default: 1.2.0)',
      'json (default: 2.1.0)',
      'jwt (2.2.1)',
      'mini_portile2 (2.4.0)',
      'minitest (5.10.3)',
      'mongo (2.11.2)',
      'multipart-post (2.1.1)',
      'mysql2 (0.5.3)',
      'net-ldap (0.15.0)',
      'net-telnet (0.1.1)',
      'nokogiri (1.10.3)',
      'openssl (default: 2.1.1)',
      'power_assert (0.2.7)',
      'psych (default: 3.0.2)',
      'rake (12.3.1)',
      'rdoc (default: 6.0.1)',
      'ruby-mysql (2.9.14)',
      'scanf (default: 1.0.0)',
      'sdbm (default: 1.0.0)',
      'stringio (default: 0.0.1)',
      'strscan (default: 1.0.0)',
      'test-unit (3.2.5)',
      'thread_safe (0.3.6)',
      'tzinfo (1.2.6)',
      'webrick (default: 1.4.2)',
      'xml-simple (1.1.5)',
      'zlib (default: 1.0.0)',
    ]
  } else {
    return (
      <Modal
        id="modal-info-about-this-environment"
        title="Unknown Environment"
        body={<p className="uk-text-center">Something went wrong...</p>}
      />
    )
  }
  return (
    <Modal
      id="modal-info-about-this-environment"
      title={`${settings.engines[engine]} Environment`}
      body={(
        <div>
          <table className="uk-table uk-table-small">
            <tbody>
              <tr>
                <td className="uk-text-right uk-width-2-5">
                  <span className="uk-text-bold">Operating System:</span>
                </td>
                <td className="uk-table-expand">
                  Ubuntu 18.04
                </td>
              </tr>
              <tr>
                <td className="uk-text-right uk-width-2-5">
                  <span className="uk-text-bold">Language Version:</span>
                </td>
                <td className="uk-table-expand">
                  {version}
                </td>
              </tr>
              <tr>
                <td className="uk-text-right uk-width-2-5">
                  <span className="uk-text-bold">Third Party Libraries:</span>
                </td>
                <td className="uk-table-expand">
                  <pre>
                    {libraries.map((library, i) => (
                      <span key={`library_${i}`}>
                        {library}
                        <br />
                      </span>
                    ))}
                  </pre>
                </td>
              </tr>
            </tbody>
          </table>

          {!hideOutputTips && (
            <TipsForGettingOutput />
          )}

          <p className="uk-text-right">
            <button className="uk-button uk-button-primary uk-modal-close" type="button">
              Ok
            </button>
          </p>
          <button
            className="uk-modal-close-outside"
            data-uk-close
            type="button"
          />
        </div>
      )}
    />
  )
}

export default ModalAboutThisEnvironment
